import { Paginator } from '@app/classes';
import { Table } from '@app/modules/table/classes/table.class';
import { AuthService } from '@app/services';
import { JobPosting } from '@models/recruiting/job-posting.model';
import { MenuColumnItem } from '@table/interfaces/menu-column-item.interface';
import { ApplicantCountColumn } from './columns/applicant-count.column';
import { CategoryColumn } from './columns/job-posting-category.column';
import { JobPostDateColumn } from './columns/job-posting-date.column';
import { LocationColumn } from './columns/job-posting-location.column';
import { StatusColumn } from './columns/job-posting-status.column';
import { JobTitleColumn } from './columns/job-posting-title.column';
import { JobPostingTypeColumn } from './columns/job-posting-type.column';

export class JobPostingTable extends Table {
    static editOption: MenuColumnItem = {
        label: 'applicant-tracker.edit',
        event: 'edit',
    };

    static deleteOption: MenuColumnItem = {
        label: 'applicant-tracker.delete',
        event: 'delete',
    };

    showMenuColumnOptions = true;
    links = true;
    protected sortProperty = 'createdAt';

    constructor(protected auth: AuthService) {
        super(auth);
        this.boot();
    }

    setColumns(): void {
        const jobPostDateColumn = new JobPostDateColumn();

        this.columns = [
            new JobTitleColumn(),
            new StatusColumn(),
            new ApplicantCountColumn(),
            new CategoryColumn(),
            new JobPostingTypeColumn(),
            new LocationColumn(),
            jobPostDateColumn,
        ];

        this.sortColumn = jobPostDateColumn;
    }

    setDataSource(): void {
        this.paginator = new Paginator(
            JobPosting.param('company', this.auth.company.id).where('status', ['active', 'draft'])
        );
    }

    getMenuColumnOptionsForRow(jobPosting: JobPosting): MenuColumnItem[] {
        if (jobPosting.draftAt) {
            return [JobPostingTable.editOption, JobPostingTable.deleteOption];
        }

        return [];
    }

    getParams(jobPosting: JobPosting): any {
        return jobPosting.draftAt ? { jobPostingId: jobPosting.id } : {};
    }

    getLink(jobPosting: JobPosting): (string | number)[] {
        return jobPosting.draftAt
            ? ['/recruiting', 'jobPostings', 'create']
            : ['/recruiting', 'jobPostings', jobPosting.id];
    }
}
